import { Injectable } from '@angular/core';
import { EmployeeVM } from '@app/cem/project/models/employee-vm';
import { Employee } from '@app/shared/models';
import { EditService } from 'app/pfm-shared/services/edit.service';

@Injectable({ providedIn: 'root' })
export class ProjectTeamService extends EditService {

  constructor() {
    super('DefaultProjectTeamMaintenanceView', ['DefaultProjectTeamId']);
  }

  public filterEmployeesByActive(value: string, employees: Employee[]): EmployeeVM[] {
    return employees.filter(this.isActive)
      .filter(this.doesNameMatch, value)
      .map(x => { return new EmployeeVM(x); })
      .sort(this.sortByName);
  }

  public filterEmployeesByActiveV2(employees: Employee[]): EmployeeVM[] {
    return employees.filter(this.isActive)
      .map(x => { return new EmployeeVM(x); })
      .sort(this.sortByName);
  }

  public checkIsAfeApprover(employeeId: number, afeApproverId: number, employeeRoleName: string): boolean {
    let isAfeApprover: boolean = false;
    if (employeeId === afeApproverId && employeeRoleName === 'Project Tech') {
      isAfeApprover = true;
    }
    return isAfeApprover;
  }

  private isActive(e: Employee): boolean {
    return e.JobStatus === 'A' || e.JobStatus === 'Active' || e.JobStatus === 'active';
  }

  private doesNameMatch(e: Employee): boolean {
    let value = this as any;
    let values = value.split(/[ ,]+/);
    let match = false;

    let firstName = e.PreferredFirstName && (e.PreferredFirstName).toString().toLowerCase() || '';
    let lastName = e.LastName && (e.LastName).toString().toLowerCase() || '';

    match = firstName.indexOf(values[0].toLowerCase()) !== -1 || lastName.indexOf(values[0].toLowerCase()) !== -1;

    if (match && values.length > 1 && values[1] !== '') {
      match = false;

      if (firstName.indexOf(values[1].toLowerCase()) !== -1 || lastName.indexOf(values[1].toLowerCase()) !== -1) {
        match = true;
      }
    }

    return match;
  }

  private sortByName(a: EmployeeVM, b: EmployeeVM) {
    if (a.FullName < b.FullName) {
      return -1;
    }

    if (a.FullName > b.FullName) {
      return 1;
    }

    return 0;
  }
}